import { Component, OnInit } from '@angular/core';
import {SearchService} from '../../services/search.service';
import { AuditService } from '../../services/audit.service';

@Component({
  selector: 'app-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.css']
})
export class SearchPanelComponent implements OnInit {

  applicationNames: {};
  selectedApplication = "";
  categoryList: any;
  selectedCategories = [];

  categoryItems: any;

  searchCriteria = {
    selectedApplication: "",
    selectedCategories: []
  };
  constructor(public searchService: SearchService, public auditService: AuditService) { }

  ngOnInit() {

    this.searchService
      .getApplication()
      .subscribe(data => {
        this.applicationNames = data;
    });
  }

  onApplicationNameChange(event: any) {
    
    this.searchService
      .getApplicationCategories(this.searchService.searchData.selectedApplication)
      .subscribe(data => {
        this.categoryList = data;
    });
  }

  categoryLists(event: any) {
    this.searchService.categoryItems = [];
    this.searchService.searchData.selectedCategoryNames = [];
    this.categoryItems = [];
    event.value.forEach(categoryName => {
      if (categoryName) {
        this
          .auditService
          .getAuditCategoryHeading(categoryName)
          .subscribe(data => {
            this.categoryItems = data;
            this.categoryItems.searchDataValue = {};
            this.searchService.categoryItems.push(data);
        });
        this.categoryList.data.categories.forEach(category => {
          if (category.code === categoryName) {
            this.searchService.searchData.selectedCategoryNames.push(category.description);
          }
        })
      }
    });
  };

}
